<template>
  <section class="container">
    <div>
      <h1>AdminD</h1>
      <div id="firebaseui-auth-container"></div>
    </div>
    <table border="1">
      <tbody>
        <tr>
          <td>id</td>
          <td>Eventid</td>
          <td>title</td>
          <td>address</td>
          <td>owner_id</td>
          <td>type</td>
          <td>ng</td>
          <td>updated_at</td>

        </tr>
        <tr v-for="item in items">
          <td>{{ item.id }}</td>
          <td>{{ item.event_id }}</td>
          <td>{{ item.title }}</td>
          <td>{{ item.address }}</td>
          <td>{{ item.owner_id }}</td>
          <td>{{ item.type }}</td>
          <td>{{ item.ng }}</td>
          <td>{{ item.updated_at.toDate() }}</td>
        </tr>
      </tbody>
    </table>

  </section>

</template>

<script>
export default {
  data() {
    return {
      items: []
    };
  },
  methods: {
    select: function(id) {
      alert(id);
    }
  },

  mounted() {
    const db = this.$store.state.firebase.database();

    db.settings({ timestampsInSnapshots: true });
    db
      .collection("events")
      .where("send_tweet", "==", true)
      .where("ng", "==", false)
      .orderBy("updated_at", "desc")
      .get()
      .then(querySnapshot => {
        this.loading = false;
        querySnapshot.forEach(doc => {
          console.log(doc.data());
          let data = doc.data();
          data.id = doc.id;
          this.items.push(data);
        });
      });
  }
};

//
</script>


<style>
.container {
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
}

.title {
  font-family: "Quicksand", "Source Sans Pro", -apple-system, BlinkMacSystemFont,
    "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif; /* 1 */
  display: block;
  font-weight: 300;
  font-size: 100px;
  color: #35495e;
  letter-spacing: 1px;
}

.subtitle {
  font-weight: 300;
  font-size: 42px;
  color: #526488;
  word-spacing: 5px;
  padding-bottom: 15px;
}

.links {
  padding-top: 15px;
}
</style>




// WEBPACK FOOTER //
// src/components/Admin.vue